import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CancelModalButton from 'components/Custom/CancelModalButton'
import DeleteButton from 'components/Custom/DeleteButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useDispatch } from 'react-redux'
import { Button, Input } from 'reactstrap'
import { onChangeSectionItem as onChangeSectionItemCourse } from 'store/Course/actions'
import { onChangeSectionItem as onChangeSectionItemGroup } from 'store/Group/actions'

const AddSection = ({ section, ...props }) => {
  let language = props.language || {}
  const dispatch = useDispatch()

  const isCourse = props?.backPath?.includes('/course')

  return (
    <div className='container-fluid'>
      <div className='row larger-spacing'>
        <div className='col-12 px-0'>
          <div className='mng-checklist_option-row d-flex align-items-center'>
            <label className='point-assignment-label mb-0'>
              {language.general ? language.general.name : null}:{' '}
            </label>
            <Input
              type='text'
              size='sm'
              name='name'
              value={section?.name}
              onChange={props.onChangeSection}
              autoFocus={section?.onCreate}
            />
          </div>
        </div>
      </div>

      {props.checklistType === 1 ? (
        <div className='row larger-spacing'>
          <div className='col-12 px-0'>
            <div className='d-flex align-items-center mt-3'>
              <label className='point-assignment-label mb-0'>
                {language.courses ? language.courses.rating : null}:{' '}
              </label>

              <div className='custom-control custom-control-info custom-radio'>
                <input
                  className='custom-control-input '
                  type='radio'
                  name='rating'
                  value='yes-no'
                  id='yes-no'
                  checked={section?.rating === 'yes-no'}
                  onChange={props.onChangeSection}
                />
                <label className='custom-control-label' htmlFor='yes-no'>
                  {language.courses ? language.courses.yes_no : null}
                </label>
              </div>
              <div className='custom-control custom-control-info custom-radio ml-4'>
                <input
                  className='custom-control-input '
                  id='1-2-3'
                  type='radio'
                  name='rating'
                  value='1-2-3'
                  checked={section?.rating === '1-2-3'}
                  onChange={props.onChangeSection}
                />
                <label className='custom-control-label' htmlFor='1-2-3'>
                  1-2-3
                </label>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <input type='hidden' value='yes-no' />
      )}
      <div className='row larger-spacing'>
        <div className='col-10 px-0'>
          <label className='point-assignment-label mb-1 mt-3'>
            {language.courses ? language.courses.items : null}:
          </label>
          {section?.items.map((item, index) => (
            <div
              className='point-assignment-input-wrapper d-flex w-50'
              key={item.id}
            >
              <Input
                type='text'
                size='sm'
                value={item.name}
                onChange={(event) => {
                  if (isCourse) {
                    dispatch(
                      onChangeSectionItemCourse(index, event.target.value)
                    )
                  } else {
                    dispatch(
                      onChangeSectionItemGroup(index, event.target.value)
                    )
                  }
                }}
              />
              <Button
                className='ml-2'
                size='sm'
                color='danger'
                outline
                onClick={() => props.removeSectionItem(index)}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </Button>
            </div>
          ))}
          <button
            className='btn btn-info py-2 mt-3'
            onClick={props.addSectionItem}
          >
            {language.courses ? language.courses.add_item : null}
          </button>
        </div>
      </div>
      <div className='row mt-7'>
        <div>
          <SubmitModalButton
            text={language.general ? language.general.save : null}
            customFn={props.saveSection}
          />

          {!section?.onCreate ? (
            <DeleteButton
              text={language.general ? language.general.delete : null}
              customFn={props.deleteSection}
            />
          ) : null}
          <CancelModalButton
            text={language.general ? language.general.cancel : null}
            customFn={props.cancelSection}
          />
        </div>
      </div>
    </div>
  )
}

export default AddSection
